module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/check-02116a6f67add25dd3be4afaeba24ea4.svg";